module.exports = {
    Description: {
        StaticInfo: `<p>The economics of hydraulic fracturing are complex and far from definitive. It is often impossible to select a single economic indicator to fracturing that will be the definitive optimized solution from all economic viewpoints for a well. A design could be significantly improved upon over the course of its development. </p>`,
        SectionsInfo: []
    },
    Overview: {
        StaticInfo: `<p>Our clients, in general, have the necessary tools and personnel to complete their economic evaluations. However, making decisions for investments in complex operations requires using   parameters with technical support, and to consider options to take action and selecting from a group the “best one,” using appropriate evaluation yardsticks. EGEP´s purpose is not to replace managerial judgement, but  to provide  our clients with our expertise, good practices and considerations to support the projects from a technical and economical perspective. </p>
      <p>The economics associated with fracturing can range from a relatively simple to a complex task. One of the fundamental issues to be addressed is the engineer’s understanding of rate acceleration vs. added reserves. Design parameters such as hydraulic horsepower and equipment costs might dominate the economic picture and an optimal economic treatment design might be a relatively simple solution. But in the vast majority of cases, the economics will be highly dependent on both treatment design and formation parameters, combined in a composite solution.  In addition to the geologic uncertainty and variability that have to be dealt with in all elements of hydraulic fracturing design, and the operational and cost aspects of placing a treatment in a reservoir, there is the added uncertainty of commodity prices and even which economic parameter should be optimized, because this will vary with each company’s financial objectives. </p>
      <p>
      
      The economic evaluation must meet a balance between anticipated productivity increase against the cost to achieve it. There are four discrete steps that the analyst must work through to evaluate the stimulation treatment:
      
      </p>
      <ul>
      <li>Determine the relevant future cash flows from the investment</li>
      <li>Determine the amount of the investment</li>
      <li>Determine the relevant parameter/figure of merit to use in evaluating the investment</li>
      <li>Compare the calculated figure of merit to an acceptance criterion or ranking of projects</li>
      </ul>
      <br/>
      <strong>The parameters to be evaluated in the project include:</strong>
      <ul>
      <li>NPV</li>
      <li>Investment efficiency</li>
      <li>Internal rate of return</li>
      <li>Payout</li>
      <li>Unit development costs</li>
      <li>
      
      <strong>
      Hydraulic Fracturing Treatment Costs: 
      </strong>
      </li>
      
      <ul>
      <li>Well and surface preparation costs location</li>
      <li>Stimulation treatment costs</li>
      <li>Drillout and flowback costs</li>
      <li>Price discounts and competitive bidding</li>
      <li>Vertical integration (if applicable)</li>
      </ul>
      </ul>`,
        SectionsInfo: []
    },
    Inputs: {
        StaticInfo: `<p>In this section our purpose is to help our client with an evaluation from a technical and economical perspective. Please consider <strong>uploading</strong> all the cost data provided by the service company or companies, as well as any other relevant data. </p>
      <p>The EGEP consultant will, if requested, help the client to evaluate all the economic criteria that should be considered when designing a hydraulic fracturing treatment, and review the elements that influence the cost of performing such a treatment, in order to guarantee that it covers all costs needed for a successful operation.</p>`,
        SectionsInfo: []
    },
    Deliverables: {
        StaticInfo: `<p>
      In this section the EGEP consultant will review and discuss his conclusions about cost-benefit and provide a report with key performance indicators, analysis, conclusions and recommendations. Among them:
      </p>
      <ul>
      
      <li><strong>Results of the economic evaluation</strong></li>
      <ul>
      <li>Net Present Worth (NPW) </li>
      <li>Internal Rate of Return (IRR) </li>
      <li>Discount Payback Period (DPBP) </li>
      <li>Profit to Investment Ratio (PIR) </li>
      <li>Benefit/Cost Ratio (B/C Ratio) or Profitability Index</li>
      <li>Wealth Growth Rate (WGR) </li>
      <li>Growth Rate of Return (GRR) </li>
      </ul>
      </ul>
      <ul>
      <li><strong>From the  Operational evaluation</strong></li>
      <ul>
      <li>Mechanical complexity (High Med Low)</li>
      <li>Well accessibility (High Med Low)</li>
      <li>Probability of success: %   (1 – Risk)</li>
      <li>Expected rate gain (bpd or cfpd)</li>
      <li>Expected producible reserves (stb or stcf)</li>
      <li>Productivity  Ratio (Jaf/Jbf) (productivity index after fracturing / before fracturing)</li>
      <li>Total cost (USD)</li>
      </ul>
      </ul>`,
        SectionsInfo: []
    }
}